import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { DataError, LoadingIndicator, Typography } from "@digital-services/ui";

import { useOrganizationContext } from "@organization/context/useOrganizationContext";
import { useGetOrganization } from "@organization/services/use-get-organization";

import { OrganizationLink } from "./OrganizationLink";

export const ParentOrganizationTab = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  const { organization: currentOrganization } = useOrganizationContext();
  const {
    organization: parentOrganization,
    isLoading,
    error
  } = useGetOrganization(currentOrganization.parentOrganizationId);

  let content: ReactNode | null = "N/A";

  if (parentOrganization?.id) {
    content = (
      <OrganizationLink
        organizationId={parentOrganization?.id}
        organizationName={parentOrganization?.name}
      />
    );
  } else if (isLoading) {
    content = <LoadingIndicator />;
  } else if (error) {
    content = (
      <DataError
        title={t("load.error.message")}
        message=""
        className="text-left! text-red-600"
      />
    );
  }

  return (
    <div>
      <div data-testid="parent-organization-name">
        <Typography variant="smallTitle">
          {t("tab-labels.parent-organization")}
        </Typography>
        <div className="my-4 text-base">{content}</div>
      </div>
    </div>
  );
};
